<template>
    <div class="row main-content" id="top">
        <priceworkflow-sidebar
            :submission="submission"
        ></priceworkflow-sidebar>
        <div class="col-md-10" id="standard-styling" style="padding-left:100px;">
            <priceworkflow-signoff-chart
                :stepsData="stepsData"
                :submission="submission"
            ></priceworkflow-signoff-chart>
            <br><br>
            <div class="h-100 d-flex justify-content-center align-items-center" v-if="loading">
                <vue-loaders-ball-beat scale="2" color="black" />
            </div>
            <div v-else>
                <section style="width:70%; max-width: 600px;">
                    <h2>PUMA PROMO SUBMISSION INFORMATION</h2>
                    <p><strong>PACKAGE TYPE: </strong>{{ submission.puma_promo.package_type }}</p>
                    <p><strong>PACKAGE DETAIL: </strong>{{ submission.puma_promo.package_details }}</p>
                    <p><strong>STYLE COUNT: </strong>{{ submission.puma_promo.style_count_ordered }}</p>
                    <p><strong>ORDER VALUE: </strong>${{ submission.puma_promo.order_value }}</p>
                    <p><strong>PREEBOOK FLOOR SET: </strong>{{ submission.puma_promo.prebook_floor_set }}</p>
                    <p><strong>ORDER #: </strong>{{ ordNums }}</p>
                    <p><strong>ADDITIONAL DETAILS: </strong>{{ submission.add_details }}</p>
                    
                    <priceworkflow-signoff-block v-if="(submissionStatus == 'p' && isApprover) || (submissionStatus == 'a' && isErpAdmin)"
                        :activityId="submission.act_id"
                        :currentStepData="currentStepData"
                        :displaySignOffNotes="displaySignOffNotes"
                        :loadingSignOff="loadingSignOff"
                        :ppId="submission.id"
                        :submissionStatus="submissionStatus"
                        @emit-sign-off="saveSignOff"
                    ></priceworkflow-signoff-block>
                </section>
            </div>
            <div>&nbsp;</div>
            <priceworkflow-timeline
                :stepsData="stepsData"
                :submission="submission"
            ></priceworkflow-timeline>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
export default {
    data() {
        return {
            currentStepData: {},
            currPriceLevel: "",
            custPrice: "",
            displaySignOffNotes: false,
            futureSignOffUsers: [],
            isApprover: false,
            isErpAdmin: false,
            loading: true,
            loadingSignOff: false,
            ordNums: "",
            signOffAction: "",
            signOffNotes: "",
            signOffStatus: "",
            stepsData: [],
            submission: {},
            submissionStatus: "",
            wfStepCurrent: "",
            wfStepUser: "",
        }
    },
    props: ['ppId'],
    created() {
        axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
            this.submission = response.data;

            this.stepsData = this.submission.steps_data;
            this.wfStepUser = this.submission.wf_step_user;
            this.wfStepCurrent = this.submission.wf_step_current;
            this.submissionStatus = this.submission.pp_status;
            this.currPriceLevel = this.submission.cust_info.price_level;
            this.futureSignOffUsers = this.submission.futureSignOffUserIds;

            if(this.submission.ord_num) {
                this.ordNums = this.submission.ord_num.split("|").join(", ");
            }

            this.loading = false;
            this.loadingSignOff = false;

            this.getCurrentStepData();
        });
    },
    computed: {
        ...mapState({ 
            user: state => state.user,
            adminUsers: state => state.priceDeviationAdmins,
            priceERPAdmins: state => state.priceERPAdmins
        })
    },
    methods: {
        saveSignOff(emittedValues) {
            this.loadingSignOff = true;
            
            let data = {
                ppId: this.submission.id,
                notes: emittedValues.signOffNotes,
                status: emittedValues.signOffStatus,
                currentStep: this.wfStepCurrent,
                signOffUser: this.user.id,
                signOffFullName: this.user.full_name
            }

            axios.post(`/api/saveSignOff`, data).then(response => {
                $("#signOffDiv").hide();
                $(".signOffNotes").val('');
                
                axios.get(`/api/getSubmission/${this.ppId}`).then(response => {
                    this.submission = response.data;

                    this.stepsData = this.submission.steps_data;
                    this.wfStepUser = this.submission.wf_step_user;
                    this.wfStepCurrent = this.submission.wf_step_current;
                    this.submissionStatus = this.submission.pp_status;
                    this.futureSignOffUsers = this.submission.futureSignOffUserIds;

                    this.getCurrentStepData();

                    this.loadingSignOff = false;

                    this.displaySignOffNotes = false;
                });
            });
        },
        findIfApprover() {
            if(this.adminUsers.includes(this.user.id)) { // Admin
                this.isApprover = true;
            } else if (this.submission.currentSignOffId == this.user.id || this.futureSignOffUsers.includes(this.user.id)) { // Next user in the workflow
                this.isApprover = true;
            } else { // Not allowed!
                this.isApprover = false;
            }
        },
        findIfErpAdmin() {
            if(this.priceERPAdmins.includes(this.user.id)) {
                this.isErpAdmin = true;
            } else {
                this.isErpAdmin = false;
            }
        },
        getCurrentStepData() {
            if(this.stepsData != null) {
                this.stepsData.forEach(element => {
                    if(element.isCurrent != null && element.isCurrent == 1) {
                        this.currentStepData = element;
                    }
                });
            }
        }
    },
    watch: {
        wfStepCurrent() {
            this.findIfApprover();
            this.findIfErpAdmin();
        }
    }
}
</script>
